import styled from "styled-components";
import { black } from "../../global/colours";
import { weight as fontWeight } from "../../global/fonts";

export const Figure = styled.figure`
  margin: 0;
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 20px;
`;
